(() => {
  const config = window.feeRetailPrices;
  if (!config) return;

  const products = new Map();
  const loading = new Set();
  const failed = new Set();
  const formatter = new Intl.NumberFormat(config.locale, { style: 'currency', currency: 'EUR' });
  let scheduled = false;

  const money = (cents) => {
    const amount = formatter.format(cents / 100);
    return config.showCurrencyCode ? `${amount} EUR` : amount;
  };

  function reveal(element) {
    element.classList.remove('fee-retail-price-pending');
  }

  function showCartPriceHint(element) {
    element.classList.remove('price--on-sale');
    const regular = element.querySelector('.price__regular > .price-item--regular');
    if (regular) regular.textContent = config.unavailable;
    reveal(element);
  }

  function applyPrice(element) {
    const product = products.get(element.dataset.feeRetailProduct);
    if (!product) return;

    const variantId = element.dataset.feeRetailVariant;
    const variant = variantId ? product.variants[variantId] : null;
    const cents = variantId ? variant?.price : product.minPrice;
    if (!Number.isSafeInteger(cents)) {
      showCartPriceHint(element);
      return;
    }

    const signature = `${variantId || 'min'}:${cents}`;
    if (element.dataset.feeRetailDone === signature) {
      reveal(element);
      return;
    }

    let display = money(cents);
    if (!variantId && product.minPrice !== product.maxPrice) {
      display = (element.dataset.feeRetailFrom || 'FEE_PRICE').replace('FEE_PRICE', display);
    }
    const regular = element.querySelector('.price__regular > .price-item--regular');
    if (regular) regular.textContent = display;

    const compare = variant?.compareAtPrice;
    const onSale = Number.isSafeInteger(compare) && compare > cents;
    element.classList.toggle('price--on-sale', onSale);
    const sale = element.querySelector('.price__sale .price-item--sale');
    if (sale) sale.textContent = money(cents);
    const oldPrice = element.querySelector('.price__sale s.price-item--regular');
    if (oldPrice && onSale) oldPrice.textContent = money(compare);

    element.dataset.feeRetailDone = signature;
    reveal(element);
  }

  async function fetchProducts(ids) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6000);
    try {
      const url = `/apps/fee-b2b?intent=retail-prices&products=${ids.join(',')}`;
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller.signal,
      });
      if (!response.ok) throw new Error('Retail price request failed');
      const result = await response.json();
      if (!result.ok || !result.products) throw new Error('Invalid retail prices');
      for (const [id, product] of Object.entries(result.products)) products.set(id, product);
    } catch {
      // The storefront price is the only available fallback during an app outage.
    } finally {
      clearTimeout(timeout);
      ids.forEach((id) => loading.delete(id));
      ids.filter((id) => !products.has(id)).forEach((id) => failed.add(id));
      document.querySelectorAll('[data-fee-retail-product]').forEach((element) => {
        if (!ids.includes(element.dataset.feeRetailProduct)) return;
        if (products.has(element.dataset.feeRetailProduct)) applyPrice(element);
        else showCartPriceHint(element);
      });
    }
  }

  function scan() {
    scheduled = false;
    const missing = new Set();
    document.querySelectorAll('[data-fee-retail-product]').forEach((element) => {
      const id = element.dataset.feeRetailProduct;
      if (products.has(id)) applyPrice(element);
      else if (!loading.has(id) && !failed.has(id)) missing.add(id);
    });
    const ids = [...missing];
    while (ids.length) {
      const batch = ids.splice(0, 20);
      batch.forEach((id) => loading.add(id));
      fetchProducts(batch);
    }
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(scan, 60);
  }

  new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
  scheduleScan();
})();
